import React from "react";
import { useTranslation } from "react-i18next";
import underlineimage from "../assets/images/title-shape.png";
import bgOverlay from "../assets/images/Esportsec/esportwoesec.png";
import friendinvite from "../assets/images/Esportsec/EsportsRoundImgs/worround.png";
const Watchvideos: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div
      className="relative w-full py-16 px-4 bg-[#070B28] overflow-hidden bg-cover bg-center"
      style={{
        backgroundImage: `url(${bgOverlay})`,
      }}
    >
      <div className="relative z-10 text-center mb-12">
        <h2 className="text-[32px] md:text-[48px] font-oswald font-extrabold text-[#ffffff] leading-tight">
        World of Esports
        </h2>
        <img src={underlineimage} alt="underline" className="mx-auto mt-2 mb-4 w-[120px] h-auto" />
        {/* <p className="text-[18px] md:text-[20px] font-oswald font-medium max-w-2xl mx-auto text-[#070B28] leading-7 mb-11">
          {t("watch.subtitle")}
        </p> */}
           <p className="text-[16px] md:text-[18px] font-medium font-proxima max-w-xl mx-auto mb-12 text-[#ffffff]">
       {t("watch.subtitle")}
      </p>
      </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-10 md:gap-20 max-w-6xl mx-auto">
        {/* Left: Image */}
        <div className="w-full md:w-1/2 flex justify-center px-2 md:px-0">
          <img
            src={friendinvite}
            alt={t("services.inviteImageAlt")}
            className="w-full max-w-[350px] md:max-w-[400px] h-auto"
          />
        </div>

        {/* Right: Text */}
        <div className="w-full md:w-1/2 text-center md:text-left px-2 md:px-0">
          <p className="text-[18px] md:text-[22px] font-oswald font-semibold text-[#ffffff] max-w-xl mx-auto md:mx-0">
          {t("watch.description")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Watchvideos;
